import Icon from "@imminently/decisively-ui/Icon";
import type { IconName } from "@imminently/decisively-ui/Icon";
import React from "react";

import type { AttributeControlType, ContainerType } from "../../../../../../types/interfaces.rulegraph";

const IconWrap =
  (name: IconName): React.ComponentType<React.SVGAttributes<SVGSVGElement>> =>
    (props) =>
      React.createElement(Icon, { ...props, name } as React.ComponentProps<typeof Icon>);

export const ControlIcons: Record<Exclude<AttributeControlType | ContainerType, "auto">, React.ComponentType> = {
  unassigned: IconWrap("help"),
  text: IconWrap("text"),
  boolean: IconWrap("boolean"),
  typography: IconWrap("typography"),
  currency: IconWrap("currency"),
  date: IconWrap("date"),
  time: IconWrap("time"),
  options: IconWrap("options"),
  entity: IconWrap("entity"),
  radio: IconWrap("radio"),
  number: IconWrap("number"),
  number_of_instances: IconWrap("number_of_instances"),
  file: IconWrap("file"),
  generative_chat: IconWrap("generative_chat"),

  repeating_container: IconWrap("repeating_container"),
  certainty_container: IconWrap("certainty_container"),
  switch_container: IconWrap("switch_container"),
  data_container: IconWrap("data_container"),

  interview_container: IconWrap("interview_container"),
};
